const pisList = {
  bindings: {
    data: '<',
    filter: '<',
    loading: '<',
    modalOptions: '<',
    onToggle: '&',
    onDelete: '&',
    hasEdit: '<',
    isLocked: '<'
  },
  templateUrl: '/modules/pis-tool/common/list/list.html',
  controller: 'PisListController',
};

angular
  .module('pis-common.module')
  .component('pisList', pisList);
